<template>
  <v-app id="inspire" class="background-grid">
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title class="text-center">{{ title }}</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-img src="img/logoscorp.jpg" max-width="400" class="center-block" />
                <p class="text-center blue--text">Para acceder al sistema ingrese su usuario y clave</p>
                <v-form>
                  <v-text-field
                    label="Usuario"
                    v-model="usuario"
                    name="login"
                    prepend-icon="mdi-account"
                    type="text"
                  ></v-text-field>

                  <v-text-field
                    id="password"
                    label="Contraseña"
                    name="password"
                    v-model="clave"
                    prepend-icon="mdi-lock"
                    hint="Ingresa tu clave"
                    :append-icon="value ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="() => (value = !value)"
                    v-on:keyup.enter="onLogin"
                    :type="value ? 'password' : 'text'"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :loading="loading" tile color="primary" @click="onLogin">
                  <v-icon dark small left>
                    mdi-account-key
                  </v-icon>
                  Ingresar
                </v-btn>
              </v-card-actions>
              <v-alert icon="mdi-message-alert" class="" border="left" color="#f6cf20" prominent elevation="24">
                {{ msg }}
              </v-alert>
            </v-card>
          </v-col>
        </v-row>

        <small style="position:absolute;bottom:0;right:0;opacity:0.0"> {{ url }} </small>
      </v-container>
    </v-main>
  </v-app>
</template>

<!-- <style>
  .background-grid {
    background-image: url('img/fondito.jpg') !important;
  }
</style> -->
<script>
  import { setAccessToken, setUserData } from './accessToken';
  import gql from 'graphql-tag';
  export default {
    props: {
      source: String,
    },
    data() {
      return {
        value: String,
        loading: false,
        msg: 'Ingrese su usuario y clave para acceder al sistema',
        usuario: '',
        clave: '',
        title: process.env.VUE_APP_NAME,
        url: process.env.VUE_APP_AUTH,
      };
    },
    apollo: {
      $client: 'httpLinkAuth',
    },
    methods: {
      async addTag() {
        this.$apollo
          .mutate({
            mutation: gql`mutation{login(login: "${this.usuario}", clave: "${this.clave}")
          { accessToken }}`,
          })
          .then(({ data: { login } }) => {
            const accessToken = login.accessToken;
            window.console.log('TOKEN:::', login);
            if (accessToken == null || accessToken.length == 0) {
              this.msg = 'Datos incorrectos, ingrese su usuario y clave para acceder al sistema.';
              this.loading = false;
            } else {
              window.console.log(accessToken);
              setAccessToken(accessToken);
              setUserData(this.usuario, this.clave);
              this.$store.state.isLogin = true;
              this.msg = 'Ingresando...'; 
              window.location.reload(true);
            }
          })
          .catch((error) => {
            this.loading = false;
            window.console.error(error);
            this.msg = 'No se pudo establecer una conexion, intentelo nuevamente';
          });
      },
      onLogin(e = null) {
        e.preventDefault();
        if (this.usuario.trim().length == 0 && this.clave.trim().length == 0) return;
        this.msg = 'Validando datos...';
        this.loading = true;
        this.addTag();
      },
    },
    mounted() {
      window.localStorage.clear();
      window.sessionStorage.clear();
    },
  };
</script>
